import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		margin: {
			margin: 0,
		},
		display: {
			position: 'absolute',
			right: 0,
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		},
		link: {
			color: '#05042E',
			fontSize: '16px',
		},
		background: {
			background: '#F1F6FA',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			[theme.breakpoints.down('sm')]: {
				background: '#fff',
				borderRadius: '3rem',
			},
		},
		text: { fontFamily: 'Poppins', fontSize: '16px' },
		subText: { fontFamily: 'Poppins', fontSize: '12px' },
		error: { fontSize: '12px', color: 'red' },
		listItems: {
			listStyleType: 'none',
			margin: 0,
			padding: 0,
			[theme.breakpoints.down('md')]: {
				background: '#F1F6FA',
				borderRadius: '2rem',
				padding: '2rem !important',
				fontSize: '16px',
			},
			[theme.breakpoints.down('xs')]: {
				background: '#F1F6FA',
				padding: '2rem !important',
				borderRadius: '2rem',
				fontSize: '12px',
				width: '350px'
			},
		},
		title: {
			color: '#78393D',
			fontSize: '36px',
			lineHeight: '45px',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				fontSize: '18px',
				lineHeight: '20px',
			},
		},
		textContainer: {
			color: '#78393D',
			fontSize: '18px',
			lineHeight: '22px',
			fontFamily: 'Poppins',
			margin: '0 2rem',
			[theme.breakpoints.down('xs')]: {
				margin: '0 2px',
				fontSize: '12px',
				lineHeight: '14.94px',
			},
		},
		gift: {
			textAlign: 'center',
			[theme.breakpoints.down('xs')]: {
				display: 'none',
			},
		},
		smallGift: {
			display: 'none',
			[theme.breakpoints.down('xs')]: {
				display: 'block',
				textAlign: 'center',
			},
		},
		smallGiftIcon: {
			[theme.breakpoints.down('sm')]: {
				width: '300px',
			},
		},
		bottomIconWrapper: {
			display: "none",
			[theme.breakpoints.down('xs')]: {
				textAlign: 'right',
				display: 'block',
			},
		},
		bottomIcon: {},
	}),
);
